// Carousel: prev/next navigation, resets on mouseleave, filters to default color on init
if (!customElements.get('product-card-slideshow')) {
  customElements.define('product-card-slideshow', class extends HTMLElement {
    connectedCallback() {
      setTimeout(() => {
        this._slides = Array.from(this.querySelectorAll('.product-card__slide'));
        this._index = 0;

        const card = this.closest('product-card');
        if (card) {
          const colorOptionIndex = parseInt(card.dataset.colorOption || '0', 10);
          const colorOptionKey = 'option' + (colorOptionIndex + 1);
          try {
            const variants = JSON.parse(card.dataset.variants || '[]');
            const defaultColor = (variants[0]?.[colorOptionKey] || '').trim().toLowerCase();
            if (defaultColor) {
              const colorSlides = this._slides.filter(s => s.dataset.slideColor === defaultColor);
              if (colorSlides.length > 0 && colorSlides.length < this._slides.length) {
                this._slides.forEach(s => { s.hidden = !colorSlides.includes(s); s.classList.remove('is-active'); });
                colorSlides[0].classList.add('is-active');
                this._slides = colorSlides;
                this._index = 0;
              }
            }
          } catch(e) {}
        }

        this.querySelector('[data-prev]')?.addEventListener('click', e => {
          e.preventDefault(); e.stopPropagation(); this.previous();
        });
        this.querySelector('[data-next]')?.addEventListener('click', e => {
          e.preventDefault(); e.stopPropagation(); this.next();
        });
        this.closest('product-card')?.addEventListener('mouseleave', () => this._goTo(0));
        this._updateArrows();
      }, 0);
    }
    previous() { if (this._index > 0) this._goTo(this._index - 1); }
    next()     { if (this._index < this._slides.length - 1) this._goTo(this._index + 1); }
    _goTo(index) {
      this._slides[this._index].classList.remove('is-active');
      this._index = index;
      this._slides[this._index].classList.add('is-active');
      this._updateArrows();
    }
    _updateArrows() {
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.hidden = this._index === 0;
      if (next) next.hidden = this._index === this._slides.length - 1;
    }
  });
}

// Size strip scroll arrows: show/hide based on overflow, scroll on click
if (!window._productCardSizeScrollReady) {
  window._productCardSizeScrollReady = true;

  window._updateSizeArrows = function(scroller) {
    const strip = scroller.closest('.product-card__size-strip');
    if (!strip) return;
    const overflowing = scroller.scrollWidth > scroller.clientWidth + 2;
    strip.querySelector('[data-size-prev]').classList.toggle('is-visible', overflowing && scroller.scrollLeft > 2);
    strip.querySelector('[data-size-next]').classList.toggle('is-visible', overflowing && scroller.scrollLeft < scroller.scrollWidth - scroller.clientWidth - 2);
  };

  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-size-prev]');
    const next = e.target.closest('[data-size-next]');
    if (!prev && !next) return;
    e.preventDefault();
    e.stopPropagation();
    const scroller = (prev || next).closest('.product-card__size-strip')?.querySelector('[data-size-items]');
    if (!scroller) return;
    scroller.scrollBy({ left: next ? 200 : -200, behavior: 'smooth' });
  });

  document.addEventListener('scroll', (e) => {
    const scroller = e.target.closest?.('[data-size-items]');
    if (!scroller) return;
    window._updateSizeArrows(scroller);
  }, true);
}

// Desktop quick-add: reveal size strip on hover, hide on mouseleave
if (!window._quickAddDesktopReady) {
  window._quickAddDesktopReady = true;
  document.addEventListener('mouseenter', (e) => {
    const btn = e.target.closest?.('[data-quick-add-desktop]');
    if (!btn) return;
    const figure = btn.closest('.product-card__figure');
    if (!figure || figure.classList.contains('is-sizes-open')) return;
    figure.classList.remove('is-wishlist-sizes-open'); // same footprint as the size strip
    figure.classList.add('is-sizes-open');
    setTimeout(() => {
      figure.querySelectorAll('[data-size-items]').forEach(window._updateSizeArrows);
    }, 260);
    const card = btn.closest('product-card');
    const sizeStrip = figure.querySelector('.product-card__size-strip');
    const reset = () => {
      figure.classList.remove('is-sizes-open');
      card?.removeEventListener('mouseleave', reset);
      sizeStrip?.removeEventListener('mouseleave', reset);
    };
    card?.addEventListener('mouseleave', reset);
    sizeStrip?.addEventListener('mouseleave', reset);
  }, true);
}

// Size strip add-to-cart: POST variant to cart, fire cart:change to open drawer
if (!window._productCardSizeStripReady) {
  window._productCardSizeStripReady = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card__size-strip [data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    btn.disabled = true;

    try {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true, detail: { sections: sectionsToBundle }
      }));

      const formData = new FormData();
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');
      if (sectionsToBundle.length) {
        formData.append('sections', sectionsToBundle.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      if (!addResponse.ok) return;
      const addData = await addResponse.json();

      const cartData = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      if (addData.sections) cartData.sections = addData.sections;

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cartData }
      }));
    } finally {
      btn.disabled = false;
    }
  });
}

// Tooltip swatch hover: after 500ms, preload the image and prefetch combined product JSON
if (!window._tooltipSwatchHoverReady) {
  window._tooltipSwatchHoverReady = true;
  window._swatchPrefetchCache = new Map();

  let _hoverTimer = null;
  let _hoverBtn = null;

  document.addEventListener('pointerenter', function(e) {
    const btn = e.target;
    if (!btn || typeof btn.matches !== 'function' || !btn.matches('.product-card__tooltip-swatch')) return;
    _hoverBtn = btn;
    clearTimeout(_hoverTimer);
    _hoverTimer = setTimeout(function() {
      if (_hoverBtn !== btn) return;
      const card = btn.closest('product-card');
      if (!card) return;

      const allMedia = card.dataset.media ? JSON.parse(card.dataset.media) : [];
      const colorLower = (btn.dataset.colorName || '').trim().toLowerCase();
      const matchedMedia = allMedia.find(function(m) { return m.color && m.color.toLowerCase() === colorLower; });
      const imageUrl = matchedMedia ? matchedMedia.url : btn.dataset.image;
      if (imageUrl) { const pre = new Image(); pre.src = imageUrl; }

      const swatchUrl = btn.dataset.productUrl || '';
      const swatchHandle = swatchUrl.split('/products/')[1]?.split('?')[0]?.split('/')[0];
      if (card.dataset.combinedListing === 'true' && swatchHandle && !window._swatchPrefetchCache.has(swatchHandle)) {
        window._swatchPrefetchCache.set(swatchHandle,
          fetch((window.Shopify?.routes?.root || '/') + 'products/' + swatchHandle + '.js')
            .then(function(r) { return r.json(); })
            .catch(function() { return null; })
        );
      }
    }, 500);
  }, true);

  document.addEventListener('pointerleave', function(e) {
    if (e.target === _hoverBtn) { clearTimeout(_hoverTimer); _hoverBtn = null; }
  }, true);
}

// Tooltip swatch click: swap image/links/price; for combined listings fetch child product and rebuild carousel + size strip
if (!window._tooltipSwatchReady) {
  window._tooltipSwatchReady = true;

  function cdnResize(url, w) { return url.replace(/(\.[^.?]+)(\?|$)/, '_' + w + 'x$1$2'); }

  function formatMoney(cents) {
    const s = (window.themeVariables && window.themeVariables.settings) || {};
    const fmt = s.moneyFormat || '${{amount}}';
    const suffix = s.currencyCodeEnabled ? ' ' + ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '') : '';
    const amount = cents / 100;
    const withCommas = (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDecimals = amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace('{{amount_no_decimals}}', noDecimals).replace('{{amount_with_comma_separator}}', withCommas).replace('{{amount}}', withCommas) + suffix;
  }

  function applySizes(card, variants) {
    card.querySelectorAll('.product-card__size-item, .wishlist-size-picker__item').forEach(function(sizeBtn) {
      const label = sizeBtn.textContent.trim();
      const match = variants.find(function(v) { return (v.option1 === label || v.option2 === label || v.option3 === label) && v.available; });
      if (match) { sizeBtn.dataset.variantId = match.id; sizeBtn.classList.remove('is-unavailable'); }
      else { delete sizeBtn.dataset.variantId; sizeBtn.classList.add('is-unavailable'); }
    });
  }

  function setCardBadges(card, html) {
    card.querySelectorAll('.product-card__meta-right, .product-card__mobile-badges').forEach(function(el) { el.innerHTML = html; });
  }

  function soldOutBadgeMarkup() {
    const label = (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.soldOutBadge) || 'Sold out';
    return '<badge-list class="badge-list"><sold-out-badge>' + label + '</sold-out-badge></badge-list>';
  }

  function applyLinks(card, url, variantId) {
    if (!url || !variantId) return;
    const href = url + (url.indexOf('?') !== -1 ? '&' : '?') + 'variant=' + variantId;
    // quick-buy-modal expects a bare handle (it fetches `products/${handle}`), not a full path.
    const handle = url.split('/products/')[1]?.split('?')[0].split('#')[0].split('/')[0];
    const modalHandle = handle ? handle + '?variant=' + variantId : href;
    card.querySelectorAll('quick-buy-modal').forEach(function(m) { m.setAttribute('handle', modalHandle); });
    card.querySelectorAll('.product-card__media, .product-card__title-row > a, .product-card__slide a, .product-card__mobile-swiper-item').forEach(function(a) { a.href = href; });
    card.querySelectorAll('input[name="id"]').forEach(function(i) { i.value = variantId; });
  }

  function applyPrice(card, variant) {
    if (variant.price == null) return;
    const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    card.querySelectorAll('sale-price').forEach(function(el) {
      el.textContent = formatMoney(variant.price);
      el.classList.toggle('text-on-sale', !!isOnSale);
      el.classList.toggle('text-subdued', !isOnSale);
    });
    card.querySelectorAll('compare-at-price').forEach(function(el) {
      if (isOnSale) { el.textContent = formatMoney(variant.compare_at_price); el.hidden = false; }
      else { el.hidden = true; }
    });
  }

  function rebuildSlideshow(card, slideshow, product, url, handle) {
    const media = (product.media || []).filter(function(m) { return m.media_type !== 'video' && m.src; });
    if (media.length) {
      const primaryImg = card.querySelector('.product-card__image--primary');
      if (primaryImg) { const src = cdnResize(media[0].src, 800); primaryImg.src = src; primaryImg.srcset = src; }
    }
    if (!slideshow || !slideshow._goTo) return;
    slideshow.querySelectorAll('[data-combined-slide]').forEach(function(s) { s.remove(); });
    slideshow.querySelectorAll('.product-card__slide').forEach(function(s) { s.hidden = true; s.classList.remove('is-active'); });
    const anchor = slideshow.querySelector('[data-prev]');
    const newSlides = [];
    media.slice(0, 8).forEach(function(m, i) {
      const slide = document.createElement('div');
      slide.className = 'product-card__slide' + (i === 0 ? ' is-active' : '');
      slide.dataset.combinedSlide = handle;
      slide.innerHTML = '<a href="' + url + '" tabindex="-1" aria-hidden="true"><img class="product-card__slide-image" src="' + cdnResize(m.src, 800) + '" loading="lazy"></a>';
      slideshow.insertBefore(slide, anchor);
      newSlides.push(slide);
    });
    if (newSlides.length) { slideshow._slides = newSlides; slideshow._index = 0; slideshow._updateArrows(); }
  }

  function filterSlidesByColor(card, slideshow, colorLower, imageUrl, url) {
    if (!slideshow || !slideshow._goTo) return;
    slideshow.querySelectorAll('[data-combined-slide]').forEach(function(s) { s.remove(); });
    const allSlides = Array.from(slideshow.querySelectorAll('.product-card__slide'));
    allSlides.forEach(function(s) { s.hidden = false; });
    const colorSlides = allSlides.filter(function(s) { return s.dataset.slideColor === colorLower; });
    if (colorSlides.length > 0) {
      allSlides.forEach(function(s) { s.hidden = !colorSlides.includes(s); s.classList.remove('is-active'); });
      colorSlides[0].classList.add('is-active');
      slideshow._slides = colorSlides; slideshow._index = 0;
    } else if (imageUrl) {
      allSlides.forEach(function(s) { s.hidden = true; s.classList.remove('is-active'); });
      const tempSlide = document.createElement('div');
      tempSlide.className = 'product-card__slide is-active';
      tempSlide.dataset.combinedSlide = colorLower;
      const href = url || card.querySelector('.product-card__media')?.href || '';
      tempSlide.innerHTML = '<a href="' + href + '" tabindex="-1" aria-hidden="true"><img class="product-card__slide-image" src="' + imageUrl + '" srcset="' + imageUrl + '"></a>';
      slideshow.insertBefore(tempSlide, slideshow.querySelector('[data-prev]'));
      slideshow._slides = [tempSlide]; slideshow._index = 0; slideshow._updateArrows?.();
    }
  }

  // Mobile swiper: keep the swipe progress bar in sync with the number of visible (non-hidden) items
  function updateMobileSwipeBar(card, visibleCount) {
    const bar = card.querySelector('[data-swipe-bar]');
    if (!bar) return;
    bar.hidden = visibleCount <= 1;
    const fill = bar.querySelector('.product-card__swipe-bar-fill');
    if (fill) {
      fill.style.width = (100 / Math.max(visibleCount, 1)) + '%';
      fill.style.transform = 'translateX(0)';
    }
  }

  // Non-combined: filter the mobile swiper to the tapped color's images (mirrors filterSlidesByColor)
  function filterMobileSwiperByColor(card, colorLower, imageUrl, url) {
    const swiper = card.querySelector('[data-mobile-swiper]');
    if (!swiper) return;
    swiper.querySelectorAll('[data-combined-swipe]').forEach(function(s) { s.remove(); });
    const allItems = Array.from(swiper.querySelectorAll('.product-card__mobile-swiper-item'));
    allItems.forEach(function(s) { s.hidden = false; });
    const colorItems = allItems.filter(function(s) { return s.dataset.swiperColor === colorLower; });
    if (colorItems.length > 0) {
      allItems.forEach(function(s) { s.hidden = !colorItems.includes(s); });
      swiper.scrollLeft = 0;
      updateMobileSwipeBar(card, colorItems.length);
    } else if (imageUrl) {
      allItems.forEach(function(s) { s.hidden = true; });
      const temp = document.createElement('a');
      temp.className = 'product-card__mobile-swiper-item';
      temp.dataset.combinedSwipe = colorLower;
      temp.href = url || card.querySelector('.product-card__media')?.href || '';
      temp.innerHTML = '<img class="product-card__mobile-swiper-image" src="' + imageUrl + '" srcset="' + imageUrl + '">';
      swiper.appendChild(temp);
      swiper.scrollLeft = 0;
      updateMobileSwipeBar(card, 1);
    }
  }

  // Combined listing: rebuild the mobile swiper from the fetched child product's media
  function rebuildMobileSwiper(card, product, url) {
    const swiper = card.querySelector('[data-mobile-swiper]');
    if (!swiper) return;
    const media = (product.media || []).filter(function(m) { return m.media_type !== 'video' && m.src; });
    if (!media.length) return;
    swiper.querySelectorAll('.product-card__mobile-swiper-item').forEach(function(s) { s.remove(); });
    media.slice(0, 8).forEach(function(m) {
      const a = document.createElement('a');
      a.className = 'product-card__mobile-swiper-item';
      a.href = url;
      a.innerHTML = '<img class="product-card__mobile-swiper-image" src="' + cdnResize(m.src, 800) + '" loading="lazy">';
      swiper.appendChild(a);
    });
    swiper.scrollLeft = 0;
    updateMobileSwipeBar(card, Math.min(media.length, 8));
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-card__tooltip-swatch');
    if (!btn) return;
    e.preventDefault();

    const card = btn.closest('product-card');
    if (!card) return;

    const colorName = btn.dataset.colorName.trim();
    const colorLower = colorName.toLowerCase();
    const swatchUrl = btn.dataset.productUrl || '';
    const swatchHandle = swatchUrl.split('/products/')[1]?.split('?')[0]?.split('/')[0];
    const isCombinedListing = card.dataset.combinedListing === 'true';
    const slideshow = card.querySelector('product-card-slideshow');

    const clickSeq = (card._swatchClickSeq = (card._swatchClickSeq || 0) + 1);

    const colorNameEl = card.querySelector('.product-card__color-name');
    if (colorNameEl) colorNameEl.textContent = btn.dataset.colorName;
    if (btn.dataset.badges !== undefined) {
      setCardBadges(card, btn.dataset.badges);
    }
    if (btn.dataset.promo !== undefined) {
      card.querySelectorAll('.product-card__promo').forEach(function(el) { el.innerHTML = btn.dataset.promo; });
    }
    const figure = card.querySelector('.product-card__figure');
    if (figure) { figure.classList.remove('is-sizes-open'); figure.classList.remove('is-wishlist-sizes-open'); }
    const swatchScope = btn.closest('.product-card__color-tooltip, .product-card__mobile-swatches-inner');
    if (swatchScope) swatchScope.querySelectorAll('.product-card__tooltip-swatch').forEach(function(s) { s.classList.remove('is-selected'); });
    btn.classList.add('is-selected');

    const allMedia = card.dataset.media ? JSON.parse(card.dataset.media) : [];
    const matchedMedia = allMedia.find(function(m) { return m.color && m.color.toLowerCase() === colorLower; });
    let imageUrl = matchedMedia ? matchedMedia.url : btn.dataset.image;
    // Fallback: borrow the src of a matching slideshow slide.
    if (!imageUrl) {
      const matchedSlideImg = card.querySelector('.product-card__slide[data-slide-color="' + CSS.escape(colorLower) + '"] img');
      if (matchedSlideImg) imageUrl = matchedSlideImg.currentSrc || matchedSlideImg.src;
    }
    const primaryImg = card.querySelector('.product-card__image--primary');
    if (primaryImg && imageUrl) { primaryImg.src = imageUrl; primaryImg.srcset = imageUrl; }

    if (isCombinedListing && swatchHandle) {
      const cached = window._swatchPrefetchCache && window._swatchPrefetchCache.get(swatchHandle);
      const promise = cached || fetch((window.Shopify?.routes?.root || '/') + 'products/' + swatchHandle + '.js').then(function(r) { return r.json(); });
      promise.then(function(product) {
        if (card._swatchClickSeq !== clickSeq || !product) return;
        const variants = product.variants || [];
        const first = variants.find(function(v) { return v.available; }) || variants[0];
        if (!variants.some(function(v) { return v.available; })) setCardBadges(card, soldOutBadgeMarkup());
        applySizes(card, variants);
        if (first) { applyLinks(card, swatchUrl, first.id); applyPrice(card, first); }
        rebuildSlideshow(card, slideshow, product, swatchUrl, swatchHandle);
        rebuildMobileSwiper(card, product, swatchUrl);
      }).catch(function(err) { console.error('[swatch] combined update failed', err); });
    } else {
      const allVariants = card.dataset.variants ? JSON.parse(card.dataset.variants) : [];
      const colorOptionKey = 'option' + (parseInt(card.dataset.colorOption || '0', 10) + 1);
      const filtered = allVariants.filter(function(v) { return (v[colorOptionKey] || '').trim().toLowerCase() === colorLower; });
      const variants = filtered.length ? filtered : allVariants;
      const first = variants.find(function(v) { return v.available; }) || variants[0];
      if (!variants.some(function(v) { return v.available; })) setCardBadges(card, soldOutBadgeMarkup());
      filterSlidesByColor(card, slideshow, colorLower, imageUrl, swatchUrl);
      filterMobileSwiperByColor(card, colorLower, imageUrl, swatchUrl);
      applySizes(card, variants);
      if (btn.dataset.price) {
        const isOnSale = !!btn.dataset.comparePrice;
        card.querySelectorAll('sale-price').forEach(function(el) {
          el.textContent = btn.dataset.price;
          el.classList.toggle('text-on-sale', isOnSale);
          el.classList.toggle('text-subdued', !isOnSale);
        });
        card.querySelectorAll('compare-at-price').forEach(function(el) {
          if (btn.dataset.comparePrice) { el.textContent = btn.dataset.comparePrice; el.hidden = false; } else { el.hidden = true; }
        });
      }
      applyLinks(card, swatchUrl, (first && first.id) || btn.dataset.variantId);
    }
  });
}

// Mobile swipe bar: update fill position as user scrolls through images
if (!window._mobileSwipeBarReady) {
  window._mobileSwipeBarReady = true;
  document.addEventListener('scroll', (e) => {
    const swiper = e.target.closest?.('[data-mobile-swiper]');
    if (!swiper) return;
    const wrap = swiper.closest('[data-swipe-wrap]');

    const bar = wrap?.querySelector('[data-swipe-bar] .product-card__swipe-bar-fill');
    if (!bar) return;
    const maxScroll = swiper.scrollWidth - swiper.offsetWidth;
    const segments = swiper.querySelectorAll('.product-card__mobile-swiper-item:not([hidden])').length;
    const progress = maxScroll > 0 ? swiper.scrollLeft / maxScroll : 0;
    bar.style.transform = `translateX(${progress * (segments - 1) * 100}%)`;
  }, true);
}

// Quick-buy modal: swap combined-listing color without navigating away
if (!window._quickBuyColorSwitchReady) {
  window._quickBuyColorSwitchReady = true;

  document.addEventListener('click', async function(e) {
    const swatch = e.target.closest('a.color-swatch, a.block-swatch, a.thumbnail-swatch');
    if (!swatch) return;

    const modal = swatch.closest('quick-buy-modal');
    if (!modal) return;

    const href = swatch.getAttribute('href') || '';
    if (!href.includes('/products/')) return;

    const afterProducts = href.split('/products/')[1];
    if (!afterProducts) return;
    const siblingHandle = afterProducts.split('?')[0].split('#')[0].split('/')[0];
    if (!siblingHandle) return;

    e.preventDefault();
    e.stopPropagation();

    if (modal._colorSwitchInflight) return;
    modal._colorSwitchInflight = true;

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const fetchUrl = root + 'products/' + siblingHandle + (href.includes('?') ? href.substring(href.indexOf('?')) : '');

      const response = await fetch(fetchUrl);
      if (!response.ok) { window.location.href = href; return; }

      const tempDoc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const quickBuyContent = tempDoc.getElementById('quick-buy-content');
      if (!quickBuyContent) { window.location.href = href; return; }

      const content = quickBuyContent.content.cloneNode(true);
      Array.from(content.querySelectorAll('noscript')).forEach(function(n) { n.remove(); });

      modal.replaceChildren(content);

      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }

      modal.dispatchEvent(new CustomEvent('dialog:after-show', { bubbles: false }));

    } catch (err) {
      window.location.href = href;
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      modal._colorSwitchInflight = false;
    }
  });
}
